import { faWebhook } from "@fortawesome/pro-duotone-svg-icons/faWebhook";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_WEBHOOKS_LINK: Breadcrumb = {
  icon: faWebhook,
  name: "Webhooks",
  to: "/dashboard/triggers/webhooks",
};
